import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconPath = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M1 17.23V3.54a1.572 1.572 0 01.465-1.126c.297-.291.697-.44 1.103-.41C8.752 2.343 12 4.654 12 6.423m0 0c0-1.756 3.632-4.054 9.426-4.413.407-.031.808.117 1.107.408.298.292.467.7.466 1.128v12.908M12 6.423L12 10.405M9.401 7.892a22.98 22.98 0 00-5.45-1.332m5.45 5.24a23.53 23.53 0 00-5.45-1.332m5.45 5.473a23.752 23.752 0 00-5.5-1.331M14.836 7.9a23.719 23.719 0 015.502-1.333m-5.65 5.984a23.723 23.723 0 015.503-1.332m-5.502 5.43a23.713 23.713 0 015.503-1.332M12 23c-.516-1.704-3.855-3.688-9.624-3.96-.777-.05-1.38-.729-1.375-1.544V3.819M12 23c.516-1.704 3.854-3.688 9.623-3.96.777-.05 1.381-.729 1.376-1.544V8.401M12 23V9.939",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});
IconPath.displayName = "IconPath";

export { IconPath };
